import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuth from '@/features/hooks/useAuth';
import useMenu from '@/features/hooks/useMenu';
import { renderIcon } from '@/utils/iconRenderer';
import internationalization from '@/assets/i18n/i18n';

export default function ProfileMenu({ isShowProfile, toggleProfileMenu }) {
    const { logout, user, SetUserLanguage } = useAuth();
    const { selectedComponentHandler } = useMenu();
    const [showSelectLang, setShowSelectLang] = useState(false);
    const { t } = useTranslation();
    const langNames = {
        tr: "Türkçe",
        ar: "العربية",
        en: "English",
        de: "Deutsch",
        kr: "Kurdish"
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('#profile-menu')) {
                toggleProfileMenu();
                setShowSelectLang(false); // Close language menu if clicked outside
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [toggleProfileMenu]);

    const lang = user?.language || 'tr';

    const changeLang = async (e) => {
        const newLang = e.currentTarget.value;
        internationalization.changeLanguage(newLang);
        await SetUserLanguage(newLang);
        setShowSelectLang(false); // Hide the language options after selection
    };

    return (
        <>
            {/* Gölgeli Arkaplan */}
            <div
                className={`fixed inset-0 bg-black bg-opacity-40 transition-opacity duration-300 ${
                    isShowProfile ? 'opacity-100 visible' : 'opacity-0 invisible'
                }`}
                onClick={toggleProfileMenu}
            ></div>

            {/* Profil Menüsü */}
            <div
                id="profile-menu"
                className={`absolute right-[-10px] top-12 w-80 bg-white rounded-lg shadow-2xl p-1 transition-transform duration-300 transform ${
                    isShowProfile ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
                } z-50`}
            >
                {/* Kullanıcı Bilgileri */}
                <div className="flex items-center mb-6 p-0 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-lg shadow-md gap-2">
                    <img
                        src={user?.image || '/images/avatar/UserNull.png'}
                        alt=""
                        className="ml-2 w-10 h-10 rounded-full border-2 border-white shadow-sm"
                    />
                    <div className="ml-3">
                        <p className="text-lg font-semibold text-white">{user?.fullName || 'Kullanıcı Adı'}</p>
                        <p className="text-sm text-blue-200">{user?.email || 'user@example.com'}</p>
                    </div>
                </div>

                {/* Profil Linki */}
                <ul>
                    <NavLink
                        to="/profile"
                        className="flex items-center gap-3 p-1 rounded-md text-gray-700 hover:bg-gray-100 transition-colors duration-200"
                        onClick={() => {
                            selectedComponentHandler("");
                            toggleProfileMenu();
                        }}
                    >
                        {renderIcon('user', 24, 'text-gray-600')}
                        <span className="text-base font-md">{t("Profil")}</span>
                    </NavLink>
                </ul>

                {/* Dil Seçimi */}
                <div className="mt-3">
                    <button
                        className="flex items-center justify-between  gap-5 w-full p-2 rounded-full hover:bg-gray-100"
                        onClick={() => setShowSelectLang((prev) => !prev)}
                    >
                        <span>{t("Dil") }</span>
                        <img  src={`/images/icons/${lang}.png`} width={20} alt={lang} />
                    </button>
                    {showSelectLang && (
                        <div className="mt-2 pr-5 ">
                            {Object.entries(langNames).map(([code,name]) => (
                                <button
                                    key={code}
                                    value={code}
                                    className="flex flex-row items-center justify-start gap-5 w-full pb-1.5 pl-4  hover:bg-gray-100 text-color-text-gray ml-3 text-sm border-b border-gray-200"
                                    onClick={(e) => changeLang(e)}
                                >
                                    <img src={`/images/icons/${code}.png`} width={20} alt={code} />
                                    <span>{t(name)}</span>
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                {/* Çıkış Yap */}
                <ul
                    className="flex items-center gap-3 p-1 rounded-md cursor-pointer text-red-600 hover:bg-red-100 transition-colors duration-200 mt-4"
                    onClick={logout}
                >
                    {renderIcon('power-off', 24, 'text-red-600')}
                    <span className="text-base font-medium">{t("Cikis")}</span>
                </ul>
            </div>
        </>
    );
}
